export const ru = [
  {
    id: 0,
    date: 'Начало Декабря 2019',
    tasks: [
      'Запуск обновленного Партнёрского кабинета'
    ],
    isFinished: true
  },
  {
    id: 1,
    date: 'Середина Февраля 2020',
    tasks: [
      'Просмотр вышестоящих партнеров в структуре',
      'Создание заявки на автоматический вывод средств в Партнёрском кабинете'
    ],
    isFinished: true
  },
  {
    id: 2,
    date: 'Начало Марта 2020',
    tasks: [
      'Возможность постановки цели на повышение квалификации',
      'Показ отчета о достижении цели в конце периода',
      'Поиск партнёров в разделе «Мои партнёры» по Email и номеру телефона',
      'Улучшение дизайна',
    ],
    isFinished: true
  },
  {
    id: 3,
    date: 'Середина Марта 2020',
    tasks: [
      'Получение уведомлений о статусах перевода и вывода средств',
      'Просмотр детализации личных продаж в разделе «Мои партнёры»',
      'Передача контактов из раздела «Журнал» другому партнёру',
      'Возможность производить групповые действия с контактами',
    ],
    isFinished: true
  },
  {
    id: 4,
    date: 'Начало Апреля 2020',
    tasks: [
      'Запуск раздела «Полезные материалы» (фото, видео, презентации и другие материалы)',
    ],
    isFinished: true
  },
  {
    id: 5,
    date: 'Май 2020',
    tasks: [
      'Отчет по продажам продуктов в структуре',
    ],
    isFinished: true
  },
  {
    id: 6,
    date: 'Июнь 2020',
    tasks: [
      'Латышский язык интерфейса',
      'Просмотр Email и номера телефона партнёра в разделе «Мои партнёры»',
      'Вывод средств на банковскую карту'
    ],
    isFinished: true
  },
  {
    id: 7,
    date: 'Август 2020',
    tasks: [
      'Переход на стадию поддержки проекта'
    ],
    isFinished: true
  }
]

export const en = [
  {
    id: 0,
    date: 'Start December 2019',
    tasks: [
      'Launch of the updated Partner Cabinet'
    ],
    isFinished: true
  },
  {
    id: 1,
    date: 'Mid February 2020',
    tasks: [
      'Displaying parent partners in the organization',
      'Automatic withdrawal of funds in the Partner Cabinet'
    ],
    isFinished: true
  },
  {
    id: 2,
    date: 'Start March 2020',
    tasks: [
      'Setting a goal for professional development',
      'Show a report on the achievement of the goal at the end of the period',
      'Search for partners in the section "My partners" by email and phone number',
      'Design Improvements',
    ],
    isFinished: true
  },
  {
    id: 3,
    date: 'Mid March 2020',
    tasks: [
      'Sending notifications about the status of funds transfer and withdrawal',
      'Viewing the details of personal sales in the "My partners" section',
      'Transferring contacts from the "Journal" section to another partner',
      'Group actions with contacts',
    ],
    isFinished: true
  },
  {
    id: 4,
    date: 'Beginning April 2020',
    tasks: [
      'Launch of the section "Useful materials" (photos, videos, presentations and other materials)'
    ],
    isFinished: true
  },
  {
    id: 5,
    date: 'May 2020',
    tasks: [
      'Report on sales of products in the organization'
    ],
    isFinished: true
  },
  {
    id: 6,
    date: 'June 2020',
    tasks: [
      'Latvian language interface',
      'View partner\s email and phone number in the "My partners" section',
      'Withdraw funds to a credit or debit card'
    ],
    isFinished: true
  },
  {
    id: 7,
    date: 'August 2020',
    tasks: [
      'Transition to maintenance phase'
    ],
    isFinished: true
  }
]

export const lv = [
  {
    id: 5,
    date: '2020. gada maijs',
    tasks: [
      'Produktu pārdošanas pārskats struktūrā',
    ],
    isFinished: true
  },
  {
    id: 6,
    date: '2020.jūnijs',
    tasks: [
      'Latvju valodas saskarne',
      'Apskatīt Partnera e-pastu un tālruņa numuru sadaļā "Mani Partneri"',
      'Naudas līdzekļu izņemšana uz bankas karti',
    ],
    isFinished: true
  },
  {
    id: 7,
    date: '2020. gada augusts',
    tasks: [
      'Pāreja uz uzturēšanas fāzi'
    ],
    isFinished: true
  }
]

export default { ru, en, lv }
